import { type ReactNode, useEffect, useState } from 'react';
import { browserName } from 'react-device-detect';
import { Spinner } from '@utilities-one/gpm-ui';

import { isGoogleChromeBrowser } from '@/components/browser/isGoogleChromeBrowser';

const getChromeOnlyMessage = () =>
  `GPM supports only Google Chrome. Your current browser is ${browserName}. Please switch to Chrome and try again.`;

type GateState = 'checking' | 'allowed' | 'blocked';

export const ChromeOnlyGate = ({ children }: Readonly<{ children: ReactNode }>) => {
  const [gateState, setGateState] = useState<GateState>('checking');

  useEffect(() => {
    if (!isGoogleChromeBrowser()) {
      window.alert(getChromeOnlyMessage());
      setGateState('blocked');
      return;
    }

    setGateState('allowed');
  }, []);

  if (gateState === 'checking') {
    return (
      <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center gap-3 bg-white">
        <Spinner className="size-8" />
        <p className="text-muted-foreground text-sm">Loading...</p>
      </div>
    );
  }

  if (gateState === 'blocked') {
    return (
      <div className="flex h-full flex-1 flex-col items-center justify-center bg-white p-6 text-center">
        <p className="max-w-md text-lg text-gray-800">{getChromeOnlyMessage()}</p>
      </div>
    );
  }

  return <>{children}</>;
};
